<template>
  <v-card
    v-show="!token"
    align="center"
    width="450"
    class="py-2 rounded"
    min-height="150"
    hover
    style="margin: 170px auto 20px auto; cursor: default; justify-content: center"
  >
    <v-card-title style="justify-content: center">ورود</v-card-title>
    <v-card-text
      >برای استفاده از تمامی امکانات نامیا وارد حساب کاربری خود
      شوید</v-card-text
    >
    <v-card-actions style="justify-content: center">
      <v-btn color="success" rounded @click="redirect()"
        >ورود به حساب کاربری</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "نامیا | صفحه اصلی",
  },
  data() {
    return {
      token: null,
    };
  },
  mounted() {
    this.token = localStorage.token;
  },
  components: {},
  methods: {
    redirect() {
      this.$router.push({
        name: "signin",
      });
    },
  },
};
</script>

<style scoped>
.v-btn.v-size--default {
  font-size: 0.8rem;
}
.v-card__subtitle,
.v-card__text {
  font-size: 0.875rem;
  font-weight: 800;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}
.rounded {
  border-radius: 20px;
}
</style>